"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasItemWithThreeMonthRuleProrationSelector = exports.isAicpaMemberMoreThanOneYearLapsedSelector = exports.isLapsedSectionRejoiningSelector = exports.isLapsedCredentialRejoiningSelector = exports.isAicpaMemberLapsedSelector = exports.isCimaMembershipLapsedSelector = exports.formatProducListData = exports.formattedUserProfileData = exports.isUserQualifiedForRemovingProration = exports.conditionalFunction = exports.stringifyZuoraDetails = exports.parseZuoraDetails = exports.RestrictionGeneralNames = exports.CimaMembershipTypes = exports.PersonQualificationLevelItems = exports.lockedNotificationMap = exports.transformRoles = exports.mapUserRoleToMRUSR = exports.CORRECT_NON_MEMBER_CHANNEL_KEY = exports.CORRECT_CGMA_CHANNEL_KEY = exports.CORRECT_MEMBER_CHANNEL_KEY = exports.INCORRECT_NON_MEMBER_CHANNEL_KEY = exports.INCORRECT_CGMA_CHANNEL_KEY = exports.INCORRECT_MEMBER_CHANNEL_KEY_2 = exports.INCORRECT_MEMBER_CHANNEL_KEY = exports.topicalSubscriptionMembershipRoles = exports.firmMembershipRoles = exports.sectionMembershipRoles = exports.credentialMembershipRoles = exports.contentSuppressMembershipMap = exports.PremiumContentMap = exports.fvsSectionMembershipMap = exports.firmMembershipMap = exports.credentialMembershipMap = exports.sectionMembershipMap = exports.fullRoleNameMap = exports.membershipNamesForPricingTable = exports.searchKeysForPremiumContentFilter = exports.premiumContentTopicalSubItems = exports.premiumContentSearchItems = exports.membershipDiscountMapNamesForCartSummary = exports.membershipMapToRoleTypeWithoutOverride = exports.onlySubscriptionRoles = exports.membershipMapToRoleType = exports.LevelNameChinesePQ = exports.LevelNameFLP = exports.LevelName = exports.RoleNamesMap = exports.membershipDiscountMapNames = exports.membershipMapNames = void 0;
exports.inactiveMembershipTermSelector = exports.isUserResignedSelector = exports.isUserMemberLapsedSelector = exports.learningPathwaySelector = exports.isCimaFLPLapsedSelector = exports.isAicpaMemberFiveYearsLapsedSelector = void 0;
const mxp_schemas_1 = require("mxp-schemas");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const firmAdmin_1 = require("../firmAdmin");
const index_1 = require("../cart/index");
exports.membershipMapNames = {
    [mxp_schemas_1.User.MembershipIdsEnum.NON_MEMBER]: 'Nonmember',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0001]: 'AICPA Membership',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002]: 'Tax Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003]: 'Tax Section Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004]: 'PFP Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005]: 'PFP Section Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0006]: 'PCPS Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0007]: 'PCPS Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0008]: 'GAQC Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0009]: 'GAQC Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0010]: 'EBPAQC Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0011]: 'EBPAQC Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0012]: 'CAQ Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0013]: 'CAQ Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0014]: 'IT Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0015]: 'IT Section Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018]: 'FVS Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019]: 'FVS Section Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022]: 'PFS Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023]: 'PFS Credential Holders Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0024]: 'ABV and CFF Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0025]: 'ABV and CFF Credential Holders Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026]: 'CITP Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027]: 'CITP Credential Holders Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0028]: 'AICPA CGMA Credential Membership',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0031]: 'CPEA Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0032]: 'CPEA Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033]: 'NFP Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034]: 'NFP Section Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0035]: 'NFPP Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0036]: 'NFPP Section Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041]: 'CEIV Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042]: 'CEIV Credential Holders Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043]: 'CVFI Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044]: 'CVFI Credential Holders Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045]: 'CFF Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046]: 'CFF Credential Holders Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047]: 'ABV Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048]: 'ABV Credential Holders Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0049]: 'FCMA Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0050]: 'MIP Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0051]: 'ACMA Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUKR0001]: 'CIMA Membership',
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription001]: 'PEVC Content Subscription',
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription002]: 'Cannabis Content Subscription',
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription003]: 'Valuations Subscription',
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription004]: 'NPF Subscription',
};
exports.membershipDiscountMapNames = {
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0001]: 'AICPA Member',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002]: 'Tax Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003]: 'Tax Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004]: 'PFP Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005]: 'PFP Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0006]: 'PCPS Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0007]: 'PCPS Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0008]: 'GAQC Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0009]: 'GAQC Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0010]: 'EBPAQC Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0011]: 'EBPAQC Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0012]: 'CAQ Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0013]: 'CAQ Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0014]: 'IT Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0015]: 'IT Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018]: 'FVS Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019]: 'FVS Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022]: 'PFS Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023]: 'PFS Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0024]: 'ABV & CFF Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0025]: 'ABV & CFF Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026]: 'CITP Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027]: 'CITP Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0028]: 'CGMA Designation Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0031]: 'CPEA Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0032]: 'CPEA Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033]: 'NFP Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034]: 'NFP Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0035]: 'NFPP Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0036]: 'NFPP Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041]: 'CEIV Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042]: 'CEIV Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043]: 'CVFI Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044]: 'CVFI Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045]: 'CFF Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046]: 'CFF Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047]: 'ABV Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048]: 'ABV Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0049]: 'FCMA Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0050]: 'MIP Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0051]: 'ACMA Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUKR0001]: 'CIMA Member',
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription001]: 'PEVC Content Subscription',
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription002]: 'Cannabis Content Subscription',
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription003]: 'Valuations Subscription',
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription004]: 'NFP Subscription',
};
var RoleNamesMap;
(function (RoleNamesMap) {
    RoleNamesMap["Section"] = "Section";
    RoleNamesMap["Members"] = "Members";
    RoleNamesMap["Firm"] = "Firm";
    RoleNamesMap["Credentials"] = "Credentials";
    RoleNamesMap["TopicalSubscription"] = "TopicalSubscription";
    RoleNamesMap["Designation"] = "Designation";
    RoleNamesMap["AICPAMembership"] = "AICPAMembership";
    RoleNamesMap["CIMAMembership"] = "CIMAMembership";
    RoleNamesMap["Nonmember"] = "Nonmember";
    RoleNamesMap["default"] = "";
})(RoleNamesMap || (exports.RoleNamesMap = RoleNamesMap = {}));
var LevelName;
(function (LevelName) {
    LevelName["cert_ba"] = "Cert BA";
    LevelName["operational_OT"] = "Operational OT";
    LevelName["operational_CS"] = "Operational CS";
    LevelName["management_OT"] = "Management OT";
    LevelName["management_CS"] = "Management CS";
    LevelName["strategic_OT"] = "Strategic OT";
    LevelName["strategic_CS"] = "Strategic CS";
})(LevelName || (exports.LevelName = LevelName = {}));
var LevelNameFLP;
(function (LevelNameFLP) {
    LevelNameFLP["Level_1"] = "Business and Finance Essentials";
    LevelNameFLP["Level_2"] = "Operational Level";
    LevelNameFLP["Level_3"] = "Operational Level";
    LevelNameFLP["Level_4"] = "Management Level";
    LevelNameFLP["Level_5"] = "Management Level";
    LevelNameFLP["Level_6"] = "Strategic Level";
    LevelNameFLP["Level_7"] = "Strategic Case Study Exam";
})(LevelNameFLP || (exports.LevelNameFLP = LevelNameFLP = {}));
var LevelNameChinesePQ;
(function (LevelNameChinesePQ) {
    LevelNameChinesePQ["Level_6"] = "Chinese Management Level";
    LevelNameChinesePQ["Level_7"] = "Chinese Strategic Level";
})(LevelNameChinesePQ || (exports.LevelNameChinesePQ = LevelNameChinesePQ = {}));
const membershipMapToRoleType = (key) => {
    switch (key) {
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0014:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0015:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034:
            return RoleNamesMap.Section;
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0035:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0036:
            return RoleNamesMap.Members;
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0006:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0007:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0008:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0009:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0010:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0011:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0012:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0013:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0031:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0032:
            return RoleNamesMap.Firm;
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0024:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0025:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0028:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0049:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0050:
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0051:
            return RoleNamesMap.Credentials;
        case mxp_schemas_1.User.MembershipIdsEnum.Subscription001:
        case mxp_schemas_1.User.MembershipIdsEnum.Subscription002:
        case mxp_schemas_1.User.MembershipIdsEnum.Subscription003:
        case mxp_schemas_1.User.MembershipIdsEnum.Subscription004:
            return RoleNamesMap.TopicalSubscription;
        // case User.MembershipIdsEnum.MRUSR0028:
        //   return RoleNamesMap.Designation;
        case mxp_schemas_1.User.MembershipIdsEnum.MRUSR0001:
            return RoleNamesMap.AICPAMembership;
        case mxp_schemas_1.User.MembershipIdsEnum.MRUKR0001:
            return RoleNamesMap.CIMAMembership;
        case mxp_schemas_1.User.MembershipIdsEnum.NON_MEMBER:
            return RoleNamesMap.Nonmember;
        default:
            return RoleNamesMap.default;
    }
};
exports.membershipMapToRoleType = membershipMapToRoleType;
exports.onlySubscriptionRoles = [
    mxp_schemas_1.User.MembershipIdsEnum.Subscription001,
    mxp_schemas_1.User.MembershipIdsEnum.Subscription002,
    mxp_schemas_1.User.MembershipIdsEnum.Subscription003,
    mxp_schemas_1.User.MembershipIdsEnum.Subscription004,
];
const membershipMapToRoleTypeWithoutOverride = (key) => {
    const name = exports.membershipMapNames[key];
    if (!(name === null || name === void 0 ? void 0 : name.includes('Override'))) {
        return (0, exports.membershipMapToRoleType)(key);
    }
    return RoleNamesMap.default;
};
exports.membershipMapToRoleTypeWithoutOverride = membershipMapToRoleTypeWithoutOverride;
exports.membershipDiscountMapNamesForCartSummary = {
    [mxp_schemas_1.User.MembershipIdsEnum.NON_MEMBER]: 'Nonmember',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0001]: 'Member',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUKR0001]: 'Member',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002]: 'Tax Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003]: 'Tax Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004]: 'PFP Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005]: 'PFP Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0006]: 'PCPS Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0007]: 'PCPS Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0008]: 'GAQC Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0009]: 'GAQC Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0010]: 'EBPAQC Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0011]: 'EBPAQC Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0012]: 'CAQ Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0013]: 'CAQ Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0014]: 'IT Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0015]: 'IT Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018]: 'FVS Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019]: 'FVS Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022]: 'PFS Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023]: 'PFS Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0024]: 'ABV and CFF Credentials',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0025]: 'ABV and CFF Credentials',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026]: 'CITP Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027]: 'CITP Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0028]: 'CGMA Designation Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0031]: 'CPEA Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0032]: 'CPEA Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033]: 'NFP Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034]: 'NFP Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0035]: 'NFPP Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0036]: 'NFPP Section Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041]: 'CEIV Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042]: 'CEIV Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043]: 'CVFI Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044]: 'CVFI Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045]: 'CFF Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046]: 'CFF Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047]: 'ABV Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048]: 'ABV Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0049]: 'FCMA Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0050]: 'MIP Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0051]: 'ACMA Credential',
};
exports.premiumContentSearchItems = {
    'tax-section': {
        title: 'Tax Section',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003],
    },
    'FVS-section': {
        title: 'Forensic and Valuation Services Section',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019],
    },
    'NFP-section': {
        title: 'Not-for-Profit Section',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034],
    },
    'PFP-section': {
        title: 'Personal Financial Planning Section',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005],
    },
    'ABV-CFF-credential': {
        title: 'ABV & CFF Credential',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0024, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0025],
    },
    'PFS-credential': {
        title: 'PFS Credential',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023],
    },
    'CITP-credential': {
        title: 'CITP Credential',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027],
    },
    'CGMA-credential': {
        title: 'CGMA Designation Credential',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0028, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0028],
    },
    'CEIV-credential': {
        title: 'CEIV Credential',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042],
    },
    'CVFI-credential': {
        title: 'CVFI Credential',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044],
    },
    'CFF-credential': {
        title: 'CFF Credential',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046],
    },
    'ABV-credential': {
        title: 'ABV Credential',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047, mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048],
    },
    // prettier-ignore
    'PEVC': {
        title: 'PEVC Content Subscription',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.Subscription001],
    },
    // prettier-ignore
    'cannabis': {
        title: 'Cannabis Content Subscription',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.Subscription002],
    },
    // prettier-ignore
    'valuations': {
        title: 'Valuations Subscription',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.Subscription003],
    },
    // prettier-ignore
    'not-for-profit': {
        title: 'NFP Subscription',
        ids: [mxp_schemas_1.User.MembershipIdsEnum.Subscription004],
    },
};
exports.premiumContentTopicalSubItems = {
    // prettier-ignore
    'PEVC': {
        name: 'Private Equity and Venture Capital Topic Subscription',
        title: 'Private Equity and Venture Capital Topic Subscriber',
    },
    // prettier-ignore
    'cannabis': {
        name: 'Cannabis Content Subscription',
        title: 'Cannabis Content Subscriber',
    },
    // prettier-ignore
    'valuations': {
        name: 'Valuations Subscription',
        title: 'Valuations Subscriber',
    },
    // prettier-ignore
    'not-for-profit': {
        name: 'NFP Subscription',
        title: 'NFP Subscriber',
    },
};
exports.searchKeysForPremiumContentFilter = {
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002]: 'tax-section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003]: 'tax-section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004]: 'PFP-section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005]: 'PFP-section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018]: 'FVS-section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019]: 'FVS-section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022]: 'PFS-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023]: 'PFS-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0024]: 'ABV-CFF-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0025]: 'ABV-CFF-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026]: 'CITP-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027]: 'CITP-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0028]: 'CGMA-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033]: 'NFP-section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034]: 'NFP-section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041]: 'CEIV-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042]: 'CEIV-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043]: 'CVFI-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044]: 'CVFI-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045]: 'CFF-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046]: 'CFF-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047]: 'ABV-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048]: 'ABV-credential',
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription001]: 'PEVC',
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription002]: 'cannabis',
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription003]: 'valuations',
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription004]: 'not-for-profit',
};
exports.membershipNamesForPricingTable = {
    [mxp_schemas_1.User.MembershipIdsEnum.NON_MEMBER]: 'Nonmembers',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0001]: 'AICPA Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002]: 'Tax Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003]: 'Tax Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004]: 'PFP Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005]: 'PFP Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0006]: 'PCPS Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0007]: 'PCPS Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0008]: 'GAQC Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0009]: 'GAQC Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0010]: 'EBPAQC Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0011]: 'EBPAQC Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0012]: 'CAQ Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0013]: 'CAQ Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0014]: 'IT Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0015]: 'IT Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018]: 'FVS Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019]: 'FVS Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022]: 'PFS Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023]: 'PFS Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0024]: 'ABV or CFF Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0025]: 'ABV or CFF Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026]: 'CITP Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027]: 'CITP Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0028]: 'CGMA Designation holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0031]: 'CPEA Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0032]: 'CPEA Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033]: 'NFP Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034]: 'NFP Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0035]: 'NFPP Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0036]: 'NFPP Section Members Override',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041]: 'CEIV Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042]: 'CEIV Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043]: 'CVFI Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044]: 'CVFI Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045]: 'CFF Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046]: 'CFF Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047]: 'ABV Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048]: 'ABV Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0049]: 'FCMA Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0050]: 'MIP Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0051]: 'ACMA Credential Holders',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUKR0001]: 'CIMA Members',
    [mxp_schemas_1.User.MembershipIdsEnum.FREE_TRIAL]: 'Free trial',
};
exports.fullRoleNameMap = {
    // Uncomment required lanes when AP-2968 will be taken in to sprint
    // [User.MembershipIdsEnum.MRUSR0001]: 'AICPA Membership',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002]: 'Tax Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003]: 'Tax Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004]: 'Personal Financial Planning Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005]: 'Personal Financial Planning Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0006]: 'Private Company Practice Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0007]: 'Private Company Practice Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0008]: 'Government Audit Quality Center',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0009]: 'Government Audit Quality Center',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0010]: 'Employee Benefit Plan Audit Quality Center',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0011]: 'Employee Benefit Plan Audit Quality Center',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0012]: 'Center for Audit Quality',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0013]: 'Center for Audit Quality',
    // [User.MembershipIdsEnum.MRUSR0014]: 'IT Section',
    // [User.MembershipIdsEnum.MRUSR0015]: 'IT Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018]: 'Forensic and Valuation Services Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019]: 'Forensic and Valuation Services Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022]: 'Personal Financial Specialist Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023]: 'Personal Financial Specialist Credential',
    // [User.MembershipIdsEnum.MRUSR0024]: 'Accredited in Business Valuation & Certified in Financial Forensics Credential',
    // [User.MembershipIdsEnum.MRUSR0025]: 'Accredited in Business Valuation & Certified in Financial Forensics Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026]: 'Certified Information Technology Professional Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027]: 'Certified Information Technology Professional Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0028]: 'Chartered Global Management Accountant Designation',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0031]: 'Center for Plain English Accounting',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0032]: 'Center for Plain English Accounting',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033]: 'Not-for-Profit Section',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034]: 'Not-for-Profit Section',
    // [User.MembershipIdsEnum.MRUSR0035]: 'NFPP Section Members',
    // [User.MembershipIdsEnum.MRUSR0036]: 'NFPP Section Members',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041]: 'Certified in Entity and Intangible Valuations Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042]: 'Certified in Entity and Intangible Valuations Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043]: 'Certified in the Valuation of Financial Instruments Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044]: 'Certified in the Valuation of Financial Instruments Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045]: 'Certified in Financial Forensics Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046]: 'Certified in Financial Forensics Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047]: 'Accredited in Business Valuation Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048]: 'Accredited in Business Valuation Credential',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0049]: 'FCMA',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0050]: 'MIP',
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0051]: 'ACMA',
};
exports.sectionMembershipMap = {
    [mxp_schemas_1.User.MembershipIdsEnum.LOGGED_IN]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.LOGGED_IN],
        title: 'Registered User',
        link: '',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002],
        title: 'Tax',
        link: '/topic/tax',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003],
        title: 'Tax',
        link: '/topic/tax',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004],
        title: 'Personal Financial Planning',
        link: '/topic/personal-financial-planning',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005],
        title: 'Personal Financial Planning',
        link: '/topic/personal-financial-planning',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033],
        title: 'Not-for-Profit',
        link: '/topic/not-for-profit',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034],
        title: 'Not-for-Profit',
        link: '/topic/not-for-profit',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018],
        title: 'Forensic and Valuation Services',
        link: '/topic/valuation-services',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019],
        title: 'Forensic and Valuation Services',
        link: '/topic/valuation-services',
    },
};
exports.credentialMembershipMap = {
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022],
        title: 'PFS credential',
        link: '/topic/personal-financial-planning',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023],
        title: 'PFS credential',
        link: '/topic/personal-financial-planning',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026],
        title: 'CITP credential',
        link: '/topic/technology',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027],
        title: 'CITP Credential',
        link: '/topic/technology',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041],
        title: 'CEIV credential',
        link: '/topic/valuation-services',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042],
        title: 'CEIV credential',
        link: '/topic/valuation-services',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043],
        title: 'CVFI credential',
        link: '/topic/valuation-services',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044],
        title: 'CVFI credential',
        link: '/topic/valuation-services',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045],
        title: 'CFF credential',
        link: '/topic/forensic-services',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046],
        title: 'CFF credential',
        link: '/topic/forensic-services',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047],
        title: 'ABV credential',
        link: '/topic/valuation-services',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048],
        title: 'ABV credential',
        link: '/topic/valuation-services',
    },
};
exports.firmMembershipMap = {
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0006]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0006],
        title: 'Private Company Practice Section',
        link: '/topic/firm-practice-management',
        accessLink: '/topic/firm-practice-management',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0007]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0007],
        title: 'Private Company Practice Section',
        link: '/topic/firm-practice-management',
        accessLink: '/topic/firm-practice-management',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0008]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0008],
        title: 'Government Audit Quality Center',
        link: '/topic/government',
        accessLink: '/topic/government',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0009]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0009],
        title: 'Government Audit Quality Center',
        link: '/topic/government',
        accessLink: '/topic/government',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0010]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0010],
        title: 'Employee Benefit Plan Audit Quality Center',
        link: '/topic/employee-benefit-plans',
        accessLink: '/topic/employee-benefit-plans',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0011]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0011],
        title: 'Employee Benefit Plan Audit Quality Center',
        link: '/topic/employee-benefit-plans',
        accessLink: '/topic/employee-benefit-plans',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0012]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0012],
        title: 'Center for Audit Quality',
        link: '/topic/center-for-audit-quality',
        accessLink: 'https://www.thecaq.org/resources/',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0013]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0013],
        title: 'Center for Audit Quality',
        link: '/topic/center-for-audit-quality',
        accessLink: 'https://www.thecaq.org/resources/',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0031]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0031],
        title: 'Center for Plain English Accounting',
        link: '/topic/center-for-plain-english-accounting',
        accessLink: '/topic/firm-practice-management/center-for-plain-english-accounting',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0032]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0032],
        title: 'Center for Plain English Accounting',
        link: '/topic/center-for-plain-english-accounting',
        accessLink: '/topic/firm-practice-management/center-for-plain-english-accounting',
    },
};
exports.fvsSectionMembershipMap = {
    Forensic: {
        title: 'FVS: Forensic Services',
        sectionTitle: 'FVS Section: Forensic Services',
        link: '/topic/forensic-services',
        rootTopicSlug: 'forensic-services',
    },
    Valuation: {
        title: 'FVS: Valuation Services',
        sectionTitle: 'FVS Section: Valuation Services',
        link: '/topic/valuation-services',
        rootTopicSlug: 'valuation-services',
    },
};
exports.PremiumContentMap = {
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0001]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0001],
        title: 'AICPA membership',
        link: '',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUKR0001]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUKR0001],
        title: 'CIMA membership',
        link: '',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002],
        title: 'Tax Section membership',
        link: 'https://www.aicpa.org/membership/sections/tax-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003],
        title: 'Tax Section membership',
        link: 'https://www.aicpa.org/membership/sections/tax-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004],
        title: 'PFP Section membership',
        link: 'https://www.aicpa.org/membership/sections/personal-financial-planning-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005],
        title: 'PFP Section membership',
        link: 'https://www.aicpa.org/membership/sections/personal-financial-planning-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0006]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0006],
        title: 'PCPS Firm membership',
        link: 'https://www.aicpa.org/interestareas/privatecompaniespracticesection.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0007]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0007],
        title: 'PCPS Firm membership',
        link: 'https://www.aicpa.org/interestareas/privatecompaniespracticesection.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0008]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0008],
        title: 'GAQC Firm membership',
        link: 'https://www.aicpa.org/interestareas/governmentalauditquality.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0009]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0009],
        title: 'GAQC Firm membership',
        link: 'https://www.aicpa.org/interestareas/governmentalauditquality.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0010]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0010],
        title: 'EBPAQC Firm membership',
        link: 'https://www.aicpa.org/interestareas/employeebenefitplanauditquality.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0011]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0011],
        title: 'EBPAQC Firm membership',
        link: 'https://www.aicpa.org/interestareas/employeebenefitplanauditquality.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0012]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0012],
        title: 'CAQ Firm membership',
        link: 'https://www.aicpa.org/interestareas/centerforauditquality.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0013]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0013],
        title: 'CAQ Firm membership',
        link: 'https://www.aicpa.org/interestareas/centerforauditquality.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018],
        title: 'FVS Section membership',
        link: 'https://www.aicpa.org/membership/sections/forensic-and-valuation-services-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019],
        title: 'FVS Section membership',
        link: 'https://www.aicpa.org/membership/sections/forensic-and-valuation-services-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022],
        title: 'PFS credential',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=3',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023],
        title: 'PFS credential',
        link: ' https://www.aicpa.org/membership/join/credentials.html?tab-1=3',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026],
        title: 'CITP credential',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=4',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027],
        title: 'CITP Credential',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=4',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0028]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0028],
        title: 'CGMA Designation Credential',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=4',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0031]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0031],
        title: 'CPEA Firm membership',
        link: 'https://www.aicpa.org/interestareas/centerforplainenglishaccounting.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0032]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0032],
        title: 'CPEA Firm membership',
        link: 'https://www.aicpa.org/interestareas/centerforplainenglishaccounting.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033],
        title: 'NFP Section membership',
        link: 'https://www.aicpa.org/membership/sections/not-for-profit-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034],
        title: 'NFP Section membership',
        link: 'https://www.aicpa.org/membership/sections/not-for-profit-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041],
        title: 'CEIV credential',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=5',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042],
        title: 'CEIV credential',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=5',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043],
        title: 'CVFI credential',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=6',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044],
        title: 'CVFI credential',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=6',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045],
        title: 'CFF credential',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=2',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046],
        title: 'CFF credential',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=2',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047],
        title: 'ABV credential',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=1',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048],
        title: 'ABV credential',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=1',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription001]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.Subscription001],
        title: 'PEVC Content Subscription',
        link: '',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription002]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.Subscription002],
        title: 'Cannabis Content Subscription',
        link: '',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription003]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.Subscription003],
        title: 'Valuations Subscription',
        link: '',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription004]: {
        oktaRole: exports.membershipMapNames[mxp_schemas_1.User.MembershipIdsEnum.Subscription004],
        title: 'NFP Subscription',
        link: '',
    },
};
// TODO: Change the link to the correct URL
exports.contentSuppressMembershipMap = {
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0001]: {
        title1: 'AICPA® & CIMA® Members',
        title2: 'AICPA or CIMA',
        title3: 'AICPA Membership',
        title4: '',
        title: 'AICPA Member',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUKR0001]: {
        title1: 'AICPA® & CIMA® Members',
        title2: 'AICPA or CIMA',
        title3: 'CIMA Membership',
        title4: '',
        title: 'CIMA Member',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0004]: {
        title1: 'PFP Section Members',
        title2: 'PFP Section Member',
        title3: 'Personal Financial Planning Section Membership',
        title4: '',
        title: 'PFP Section',
        acronym: '',
        link: 'https://www.aicpa.org/membership/sections/personal-financial-planning-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0005]: {
        title1: 'PFP Section Members',
        title2: 'PFP Section Member',
        title3: 'Personal Financial Planning Section Membership',
        title4: '',
        title: 'PFP Section',
        acronym: '',
        link: 'https://www.aicpa.org/membership/sections/personal-financial-planning-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0018]: {
        title1: 'FVS Section Members',
        title2: 'FVS Section Member',
        title3: 'Forensic & Valuation Services Section Membership',
        title4: '',
        title: 'FVS Section',
        acronym: '',
        link: 'https://www.aicpa.org/membership/sections/forensic-and-valuation-services-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0019]: {
        title1: 'FVS Section Members',
        title2: 'FVS Section Member',
        title3: 'Forensic & Valuation Services Section Membership',
        title4: '',
        title: 'FVS Section',
        acronym: '',
        link: 'https://www.aicpa.org/membership/sections/forensic-and-valuation-services-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0033]: {
        title1: 'NFP Section Members',
        title2: 'NFP Section Member',
        title3: 'Not-for-Profit Section Member',
        title4: 'Not-for-Profit Section',
        title: 'NFP Section',
        acronym: '',
        link: 'https://www.aicpa.org/membership/sections/not-for-profit-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0034]: {
        title1: 'NFP Section Members',
        title2: 'NFP Section Member',
        title3: 'Not-for-Profit Section Member',
        title4: 'Not-for-Profit Section',
        title: 'NFP Section',
        acronym: '',
        link: 'https://www.aicpa.org/membership/sections/not-for-profit-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0002]: {
        title1: 'Tax Section Members',
        title2: 'Tax Section Member',
        title3: 'Tax Section Membership',
        title4: '',
        title: 'Tax Section',
        acronym: '',
        link: 'https://www.aicpa.org/membership/sections/tax-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0003]: {
        title1: 'Tax Section Members',
        title2: 'Tax Section Member',
        title3: 'Tax Section Membership',
        title4: '',
        title: 'Tax Section',
        acronym: '',
        link: 'https://www.aicpa.org/membership/sections/tax-section.html',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047]: {
        title1: 'ABV Credential Holders',
        title2: 'ABV Credential Holder',
        title3: 'Accredited in Business Valuation Credential',
        title4: '',
        title: 'ABV Credential',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=1',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048]: {
        title1: 'ABV Credential Holders',
        title2: 'ABV Credential Holder',
        title3: 'Accredited in Business Valuation Credential',
        title4: '',
        title: 'ABV Credential',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=1',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045]: {
        title1: 'CFF Credential Holders',
        title2: 'CFF Credential Holder',
        title3: 'Certified in Financial Forensics Xredential',
        title4: '',
        title: 'CFF Credential',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=2',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046]: {
        title1: 'CFF Credential Holders',
        title2: 'CFF Credential Holder',
        title3: 'Certified in Financial Forensics Credential',
        title4: '',
        title: 'CFF Credential',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=2',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022]: {
        title1: 'PFS Credential Holders',
        title2: 'PFS Credential Holder',
        title3: 'Personal Financial Specialist Credential',
        title4: '',
        title: 'PFS Credential',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=3',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023]: {
        title1: 'PFS Credential Holders',
        title2: 'PFS Credential Holder',
        title3: 'Personal Financial Specialist Credential',
        title4: '',
        title: 'PFS Credential',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=3',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026]: {
        title1: 'CITP Credential Holders',
        title2: 'CITP Credential Holder',
        title3: 'Certified Information Technology Professional Credential',
        title4: '',
        title: 'CITP Credential',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=4',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027]: {
        title1: 'CITP Credential Holders',
        title2: 'CITP Credential Holder',
        title3: 'Certified Information Technology Professional Credential',
        title4: '',
        title: 'CITP Credential',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=4',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0028]: {
        title1: 'CGMA Designation Credential Holders',
        title2: 'CGMA Designation Credential Holder',
        title3: 'Chartered Global Management Accountant Designation Credential',
        title4: '',
        title: 'CGMA Designation Credential',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=4',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041]: {
        title1: 'CEIV Credential Holders',
        title2: 'CEIV Credential Holder',
        title3: 'Certified in Entity and Intangible Valuations Credential',
        title4: '',
        title: 'CEIV Credential',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=5',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042]: {
        title1: 'CEIV Credential Holders',
        title2: 'CEIV Credential Holder',
        title3: 'Certified in Entity and Intangible Valuations Credential',
        title4: '',
        title: 'CEIV Credential',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=5',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043]: {
        title1: 'CVFI Credential Holders',
        title2: 'CVFI Credential Holder',
        title3: 'Certified in the Valuation of Financial Instruments Credential',
        title4: '',
        title: 'CVFI Credential',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=6',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044]: {
        title1: 'CVFI Credential Holders',
        title2: 'CVFI Credential Holder',
        title3: 'Certified in the Valuation of Financial Instruments Credential',
        title4: '',
        title: 'CVFI Credential',
        acronym: '',
        link: 'https://www.aicpa.org/membership/join/credentials.html?tab-1=6',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0006]: {
        title1: 'PCPS Members',
        title2: 'PCPS Member',
        title3: 'Private Company Practice Section Member',
        title4: 'Private Company Practice Section',
        title: 'PCPS Membership',
        acronym: 'PCPS',
        link: '/topic/firm-practice-management',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0007]: {
        title1: 'PCPS Members',
        title2: 'PCPS Member',
        title3: 'Private Company Practice Section Member',
        title4: 'Private Company Practice Section',
        title: 'PCPS Membership',
        acronym: 'PCPS',
        link: '/topic/firm-practice-management',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0008]: {
        title1: 'GAQC Members',
        title2: 'GAQC Member',
        title3: 'Government Audit Quality Center Member',
        title4: 'Government Audit Quality Center',
        title: 'GAQC Membership',
        acronym: 'GAQC',
        link: '/topic/government',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0009]: {
        title1: 'GAQC Members',
        title2: 'GAQC Member',
        title3: 'Government Audit Quality Center Member',
        title4: 'Government Audit Quality Center',
        title: 'GAQC Membership',
        acronym: 'GAQC',
        link: '/topic/government',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0010]: {
        title1: 'EBPAQC Members',
        title2: 'EBPAQC Member',
        title3: 'Employee Benefit Plan Audit Quality Center Member',
        title4: 'Employee Benefit Plan Audit Quality Center',
        title: 'EBPAQC Membership',
        acronym: 'EBPAQC',
        link: '/topic/Employee-Benefit-Plan Audit-Quality-Center',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0011]: {
        title1: 'EBPAQC Members',
        title2: 'EBPAQC Member',
        title3: 'Employee Benefit Plan Audit Quality Center Member',
        title4: 'Employee Benefit Plan Audit Quality Center',
        title: 'EBPAQC Membership',
        acronym: 'EBPAQC',
        link: '/topic/Employee-Benefit-Plan Audit-Quality-Center',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0012]: {
        title1: 'CAQ Members',
        title2: 'CAQ Member',
        title3: 'Center for Audit Quality Member',
        title4: 'Center for Audit Quality',
        title: 'CAQ Membership',
        acronym: 'CAQ',
        link: '/topic/Center-for-Audit-Quality',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0013]: {
        title1: 'CAQ Members',
        title2: 'CAQ Member',
        title3: 'Center for Audit Quality Member',
        title4: 'Center for Audit Quality',
        title: 'CAQ Membership',
        acronym: 'CAQ',
        link: '/topic/Center-for-Audit-Quality',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0031]: {
        title1: 'CPEA Members',
        title2: 'CPEA Member',
        title3: 'Center for Plain English Accounting Member',
        title4: 'Center for Plain English Accounting',
        title: 'CPEA Membership',
        acronym: 'CPEA',
        link: '/topic/Center-for-Plain-English-Accounting',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.MRUSR0032]: {
        title1: 'CPEA Members',
        title2: 'CPEA Member',
        title3: 'Center for Plain English Accounting Member',
        title4: 'Center for Plain English Accounting',
        title: 'CPEA Membership',
        acronym: 'CPEA',
        link: '/topic/Center-for-Plain-English-Accounting',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription001]: {
        title1: 'PEVC Content Subscriptions',
        title2: 'PEVC Content Subscriber',
        title3: exports.premiumContentTopicalSubItems.PEVC.title,
        title4: '',
        title: 'PEVC Content Subscription',
        acronym: '',
        link: '/cpe-learning/content/private-equity-venture-capital-valuation-subscription',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription002]: {
        title1: 'Cannabis Content Subscriptions',
        title2: 'Cannabis Content Subscriber',
        title3: exports.premiumContentTopicalSubItems.cannabis.title,
        title4: '',
        title: 'Cannabis Content Subscription',
        acronym: '',
        link: '/premium-content/all/cannabis',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription003]: {
        title1: 'Valuations Subscriptions',
        title2: 'Valuations Subscriber',
        title3: exports.premiumContentTopicalSubItems.valuations.title,
        title4: '',
        title: 'Valuations Subscription',
        acronym: '',
        link: '/cpe-learning/content/valuation-subscription',
    },
    [mxp_schemas_1.User.MembershipIdsEnum.Subscription004]: {
        title1: 'NFP Subscribers',
        title2: 'NFP Subscriber',
        title3: exports.premiumContentTopicalSubItems['not-for-profit'].title,
        title4: '',
        title: 'NFP Subscription',
        acronym: '',
        link: '/cpe-learning/content/not-for-profit-topic-subscription',
    },
};
exports.credentialMembershipRoles = [
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0022,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0023,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0024,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0025,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0026,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0027,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0028,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0041,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0042,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0043,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0044,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0045,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0046,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0047,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0048,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0049,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0050,
    mxp_schemas_1.User.MembershipIdsEnum.MRUSR0051,
];
exports.sectionMembershipRoles = [
    'excacc.MRUSR0002',
    'excacc.MRUSR0003',
    'excacc.MRUSR0004',
    'excacc.MRUSR0005',
    'excacc.MRUSR0033',
    'excacc.MRUSR0034',
    'excacc.MRUSR0018',
    'excacc.MRUSR0019',
];
exports.firmMembershipRoles = [
    'excacc.MRUSR0006',
    'excacc.MRUSR0007',
    'excacc.MRUSR0008',
    'excacc.MRUSR0009',
    'excacc.MRUSR0010',
    'excacc.MRUSR0011',
    'excacc.MRUSR0012',
    'excacc.MRUSR0013',
    'excacc.MRUSR0031',
    'excacc.MRUSR0032',
];
exports.topicalSubscriptionMembershipRoles = [
    mxp_schemas_1.User.MembershipIdsEnum.Subscription001,
    mxp_schemas_1.User.MembershipIdsEnum.Subscription002,
    mxp_schemas_1.User.MembershipIdsEnum.Subscription003,
    mxp_schemas_1.User.MembershipIdsEnum.Subscription004,
];
// Corrections
exports.INCORRECT_MEMBER_CHANNEL_KEY = 'members-us';
exports.INCORRECT_MEMBER_CHANNEL_KEY_2 = 'MRUSR0001';
exports.INCORRECT_CGMA_CHANNEL_KEY = 'cgma-credential-holder-us';
exports.INCORRECT_NON_MEMBER_CHANNEL_KEY = 'non-members-us';
exports.CORRECT_MEMBER_CHANNEL_KEY = 'excacc.MRUSR0001';
exports.CORRECT_CGMA_CHANNEL_KEY = 'excacc.MRUSR0028';
exports.CORRECT_NON_MEMBER_CHANNEL_KEY = 'nonMemberRole';
const mapUserRoleToMRUSR = (cTRole) => {
    switch (cTRole) {
        case exports.INCORRECT_MEMBER_CHANNEL_KEY:
        case exports.INCORRECT_MEMBER_CHANNEL_KEY_2:
            return [exports.CORRECT_MEMBER_CHANNEL_KEY];
        case exports.INCORRECT_CGMA_CHANNEL_KEY:
            return [exports.CORRECT_CGMA_CHANNEL_KEY];
        case exports.INCORRECT_NON_MEMBER_CHANNEL_KEY:
            return [exports.CORRECT_NON_MEMBER_CHANNEL_KEY];
        case mxp_schemas_1.User.MembershipIdsEnum.FREE_TRIAL:
            return [mxp_schemas_1.User.MembershipIdsEnum.FREE_TRIAL];
        case mxp_schemas_1.User.MembershipIdsEnum.Centers_Affiliated:
            return [mxp_schemas_1.User.MembershipIdsEnum.Centers_Affiliated];
        default:
            return [];
    }
};
exports.mapUserRoleToMRUSR = mapUserRoleToMRUSR;
const transformRoles = (price) => {
    const channelKey = price && price.channel && price.channel.obj && price.channel.obj.key;
    const mappedRoles = (0, exports.mapUserRoleToMRUSR)(channelKey);
    const roles = (price && price.channel && price.channel.obj ? price.channel.obj.key.match(/excacc.MRU[SK]R\d\d\d\d/gm) || [] : []);
    const transformedRoles = mappedRoles && mappedRoles.length ? mappedRoles : roles;
    return transformedRoles;
};
exports.transformRoles = transformRoles;
exports.lockedNotificationMap = {
    member: {
        header: 'Reserved for AICPA members',
        joinPromptText: '',
        joinAICPA: 'Join to gain access to exclusive content:',
        benefitList: [
            'Tools and resources unique to each section: Tax, Not-for-Profit, Personal Financial Planning and Forensic & Valuation Services',
            'Timely news, technical updates, and specialized communications by subject area',
            'Free CPE-qualifying webcasts available for each section you join',
        ],
        becomeMemberButton: '',
        pathwayUrl: '',
        learnMoreLink: '',
        learnMoreUrl: 'https://www.aicpa.org/membership/join.html',
        buttonTitle: '',
        type: RoleNamesMap.AICPAMembership,
        oneLineDescr: '',
        propPageLink: '',
    },
    section: {
        header: 'Reserved for AICPA section members',
        joinPromptText: 'Join one of our specialized sections to gain access to exclusive content:',
        joinAICPA: '',
        benefitList: [
            'Tools and resources unique to each section: Tax, Not-for-Profit, Personal Financial Planning and Forensic & Valuation Services',
            'Timely news, technical updates, and specialized communications by subject area',
            'Free CPE-qualifying webcasts available for each section you join',
        ],
        becomeMemberButton: 'https://www.aicpa.org/membership/sections.html',
        pathwayUrl: '',
        learnMoreLink: '',
        learnMoreUrl: '',
        buttonTitle: '',
        type: RoleNamesMap.Section,
        oneLineDescr: '',
        propPageLink: '',
    },
    credential: {
        header: 'Reserved for AICPA credential holders',
        joinPromptText: 'Set yourself apart from the crowd with an AICPA credential.',
        joinAICPA: '',
        benefitList: [
            'Elevate client and employer confidence by holding a credential granted by the AICPA, one of the most trusted professional bodies worldwide',
            'Accelerate your career in advisory services',
            'Increase your earning potential in a profession that has experienced 190% growth over the past 10 years',
        ],
        buttonTitle: 'Find your AICPA credential',
        becomeMemberButton: '',
        pathwayUrl: 'https://www.aicpa.org/membership/join/credentials.html',
        learnMoreLink: 'https://www.aicpa.org/membership/join/credentials.html',
        learnMoreUrl: '',
        type: RoleNamesMap.Credentials,
        oneLineDescr: '',
        propPageLink: 'https://www.aicpa.org/membership/join/credentials.html',
    },
    multiSections: {
        header: 'Reserved for AICPA section members',
        joinPromptText: 'Join one of our specialized sections to gain access to exclusive content:',
        joinAICPA: '',
        benefitList: [
            'Tools and resources unique to each section: Tax, Not-for-Profit, Personal Financial Planning and Forensic & Valuation Services',
            'Timely news, technical updates, and specialized communications by subject area',
            'Free CPE-qualifying webcasts available for each section you join',
        ],
        buttonTitle: 'Find your AICPA credential',
        becomeMemberButton: 'https://www.aicpa.org/membership/sections.html',
        pathwayUrl: '',
        learnMoreLink: 'Find your section',
        learnMoreUrl: '',
        type: RoleNamesMap.Section,
        oneLineDescr: '',
        propPageLink: 'Find your section',
    },
    multiCredentials: {
        header: 'Reserved for AICPA credential holders',
        joinPromptText: 'Set yourself apart from the crowd with an AICPA credential.',
        joinAICPA: '',
        benefitList: [
            'Elevate client and employer confidence by holding a credential granted by the AICPA, one of the most trusted professional bodies worldwide',
            'Accelerate your career in advisory services',
            'Increase your earning potential in a profession that has experienced 190% growth over the past 10 years',
        ],
        buttonTitle: 'Find your AICPA credential',
        becomeMemberButton: '',
        pathwayUrl: 'https://www.aicpa.org/membership/join/credentials.html',
        learnMoreLink: 'https://www.aicpa.org/membership/join/credentials.html',
        learnMoreUrl: '',
        type: RoleNamesMap.Credentials,
        oneLineDescr: 'Differentiate yourself and elevate clients’ confidence by holding a credential granted by the AICPA, one of the most trusted professional bodies worldwide.',
        propPageLink: 'https://www.aicpa.org/membership/join/credentials.html',
    },
};
exports.PersonQualificationLevelItems = {
    [mxp_schemas_1.MembershipTypes.Pathway.PQ]: mxp_schemas_1.User.QualificationLevelStatus.PendingProgressionEngineRun,
    [mxp_schemas_1.MembershipTypes.Pathway.FLP]: mxp_schemas_1.User.QualificationLevelStatus.PendingProgressionEngineRun,
    [mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L4]: mxp_schemas_1.User.QualificationLevelStatus.PendingTPConfirmation,
    [mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L7]: mxp_schemas_1.User.QualificationLevelStatus.PendingTPConfirmation,
};
exports.CimaMembershipTypes = {
    // TODO: Will remove this once auto upgraded lambda is implemented
    [mxp_schemas_1.MembershipTypes.ParamCimaTypes.REGULAR_CORE]: {
        membershipKey: mxp_schemas_1.MembershipTypes.MembershipKeys.REGULAR,
        tierCode: mxp_schemas_1.MembershipTypes.TierCode.CORE,
    },
    [mxp_schemas_1.MembershipTypes.ParamCimaTypes.AFFILIATE_CORE]: {
        membershipKey: mxp_schemas_1.MembershipTypes.MembershipKeys.AFFILIATE,
        tierCode: mxp_schemas_1.MembershipTypes.TierCode.CORE,
    },
    [mxp_schemas_1.MembershipTypes.ParamCimaTypes.AFFILIATE_PRE]: {
        membershipKey: mxp_schemas_1.MembershipTypes.MembershipKeys.AFFILIATE,
        tierCode: mxp_schemas_1.MembershipTypes.TierCode.PRE,
    },
    [mxp_schemas_1.MembershipTypes.ParamCimaTypes.RETIRED_CORE]: {
        membershipKey: mxp_schemas_1.MembershipTypes.MembershipKeys.RETIRED,
        tierCode: mxp_schemas_1.MembershipTypes.TierCode.CORE,
    },
    [mxp_schemas_1.MembershipTypes.ParamCimaTypes.REGULAR_ESSENTIALS]: {
        membershipKey: mxp_schemas_1.MembershipTypes.MembershipKeys.REGULAR,
        tierCode: mxp_schemas_1.MembershipTypes.TierCode.ESSENTIALS,
    },
    [mxp_schemas_1.MembershipTypes.ParamCimaTypes.REGULAR_ADVANCE]: {
        membershipKey: mxp_schemas_1.MembershipTypes.MembershipKeys.REGULAR,
        tierCode: mxp_schemas_1.MembershipTypes.TierCode.ADVANCE,
    },
    [mxp_schemas_1.MembershipTypes.ParamCimaTypes.REGULAR_LEAD]: {
        membershipKey: mxp_schemas_1.MembershipTypes.MembershipKeys.REGULAR,
        tierCode: mxp_schemas_1.MembershipTypes.TierCode.LEAD,
    },
    [mxp_schemas_1.MembershipTypes.ParamCimaTypes.REGULAR_FELLOW_CORE]: {
        membershipKey: mxp_schemas_1.MembershipTypes.MembershipKeys.REGULAR,
        tierCode: mxp_schemas_1.MembershipTypes.TierCode.FELLOW_CORE,
    },
    [mxp_schemas_1.MembershipTypes.ParamCimaTypes.CGMA_AFFILIATE_CORE]: {
        membershipKey: mxp_schemas_1.MembershipTypes.MembershipKeys.CGMA_AFFILIATE,
        tierCode: mxp_schemas_1.MembershipTypes.TierCode.CORE,
    },
    [mxp_schemas_1.MembershipTypes.ParamCimaTypes.CGMA_AFFILIATE_RETIRED]: {
        membershipKey: mxp_schemas_1.MembershipTypes.MembershipKeys.CGMA_AFFILIATE,
        tierCode: mxp_schemas_1.MembershipTypes.TierCode.RETIRED,
    },
};
var RestrictionGeneralNames;
(function (RestrictionGeneralNames) {
    RestrictionGeneralNames["DEFAULT"] = "";
    RestrictionGeneralNames["SECTIONS"] = "Section Member";
    RestrictionGeneralNames["CREDENTIALS"] = "Credential Holder";
    RestrictionGeneralNames["TOPICAL_SUBSCRIPTION"] = "Premium Subscriber";
    RestrictionGeneralNames["FIRM_MEMBERSHIP"] = "Firm Member";
})(RestrictionGeneralNames || (exports.RestrictionGeneralNames = RestrictionGeneralNames = {}));
const parseZuoraDetails = data => {
    var _a;
    const array = data.split(';');
    const entities = (_a = array[1]) === null || _a === void 0 ? void 0 : _a.split('|').map(id => {
        var _a;
        const nameAndValue = id.split(':');
        const ent = (_a = Object.entries(entityAbbreviationMap).find(i => i[1] === nameAndValue[0])) === null || _a === void 0 ? void 0 : _a[0];
        return {
            [ent]: nameAndValue[1],
        };
    });
    return {
        latestCurrency: array[0],
        latestEntity: Object.keys(entities[0])[0] || null,
        entities: entities.reduce((acc, e) => (Object.assign(Object.assign({}, acc), e)), {}),
    };
};
exports.parseZuoraDetails = parseZuoraDetails;
const entityAbbreviationMap = {
    [mxp_schemas_1.ZuoraTypes.LegalEntity.ASSOCIATION]: 'a',
    [mxp_schemas_1.ZuoraTypes.LegalEntity.CIMA]: 'c',
};
const getAbbreviationFromEntity = ent => {
    return entityAbbreviationMap[ent] || 'error';
};
const stringifyZuoraDetails = data => {
    const otherEntities = Object.entries(data.entities).filter(ent => ent[0] !== data.latestEntity);
    const ents = [[data.latestEntity, data.entities[data.latestEntity]], ...otherEntities];
    return `${data.latestCurrency};${ents
        .map(e => `${getAbbreviationFromEntity(e[0])}:${e[1]}`)
        .join('|')}`;
};
exports.stringifyZuoraDetails = stringifyZuoraDetails;
const conditionalFunction = (condition, successReturn, partialReturn) => {
    if (condition) {
        return successReturn;
    }
    if (partialReturn || partialReturn === 0) {
        return partialReturn;
    }
};
exports.conditionalFunction = conditionalFunction;
// Reference Selector Names in ""shouldRemoveProrationSelector"" -> packages/client/src/modules/cart/selectors.ts
const isUserQualifiedForRemovingProration = (userProfile, userOktaData, productList, cart, useRemoveProration, log) => {
    // 1. isCimaMembershipLapsedSelector
    // 2. isAicpaMemberLapsedSelector
    // 3. isLapsedCredentialRejoiningSelector
    // 4. isLapsedSectionRejoiningSelector
    // 5. isAicpaMemberFiveYearsLapsedSelector
    // 6. hasItemWithThreeMonthRuleProrationSelector
    var _a;
    // Construct user info into data same with getMyProfile response in Redux
    const userData = (0, exports.formattedUserProfileData)(userProfile, userOktaData);
    log.info(`userData - ${JSON.stringify(userData)}`);
    const productListData = (0, exports.formatProducListData)(productList);
    const productListByTypes = productListData === null || productListData === void 0 ? void 0 : productListData.productListByTypes;
    const inactiveMembership = (_a = userData === null || userData === void 0 ? void 0 : userData.inactiveMemberships) === null || _a === void 0 ? void 0 : _a[0];
    const cartLineItems = cart === null || cart === void 0 ? void 0 : cart.lineItems;
    log.info(`cartLineItems - ${JSON.stringify(cartLineItems)}`);
    const inactiveCredentials = userData === null || userData === void 0 ? void 0 : userData.inactiveCredentials;
    const inactiveSections = userData === null || userData === void 0 ? void 0 : userData.inactiveSections;
    const personAccountData = userData === null || userData === void 0 ? void 0 : userData.personAccountData;
    const personOktaData = userData === null || userData === void 0 ? void 0 : userData.data;
    const isUserMemberLapsed = (0, exports.isUserMemberLapsedSelector)(personOktaData);
    log.info(`isUserMemberLapsed - ${isUserMemberLapsed}`);
    const learningPathway = (0, exports.learningPathwaySelector)(personAccountData);
    log.info(`learningPathway - ${learningPathway}`);
    const isUserResigned = (0, exports.isUserResignedSelector)(personOktaData, inactiveMembership);
    log.info(`isUserResigned - ${isUserResigned}`);
    const inactiveMembershipTerm = (0, exports.inactiveMembershipTermSelector)(userData === null || userData === void 0 ? void 0 : userData.inactiveMemberships);
    log.info(`inactiveMembershipTerm - ${inactiveMembershipTerm}`);
    const isCimaFLPLapsed = (0, exports.isCimaFLPLapsedSelector)({
        inactiveMembership,
        learningPathway,
        isUserResigned,
        isUserMemberLapsed,
    });
    log.info(`isCimaFLPLapsed - ${isCimaFLPLapsed}`);
    const isCimaMemberLapsed = (0, exports.isCimaMembershipLapsedSelector)({
        inactiveMembership,
        isCimaFLPLapsed,
        isUserResigned,
        isUserMemberLapsed,
    });
    log.info(`isCimaMemberLapsed - ${isCimaMemberLapsed}`);
    const isAicpaMemberLapsed = (0, exports.isAicpaMemberLapsedSelector)(inactiveMembership, isUserMemberLapsed, isUserResigned);
    log.info(`isAicpaMemberLapsed - ${isAicpaMemberLapsed}`);
    const isAicpaMemberFiveYearsLapsed = (0, exports.isAicpaMemberFiveYearsLapsedSelector)(inactiveMembershipTerm, isAicpaMemberLapsed);
    log.info(`isAicpaMemberFiveYearsLapsed - ${isAicpaMemberFiveYearsLapsed}`);
    const isLapsedCredentialRejoining = (0, exports.isLapsedCredentialRejoiningSelector)(productListByTypes, cartLineItems, inactiveCredentials);
    log.info(`isLapsedCredentialRejoining - ${isLapsedCredentialRejoining}`);
    const isLapsedSectionRejoining = (0, exports.isLapsedSectionRejoiningSelector)(inactiveSections, cartLineItems);
    log.info(`isLapsedSectionRejoining - ${isLapsedSectionRejoining}`);
    const isAicpaMemberMoreThanOneYearLapsed = (0, exports.isAicpaMemberMoreThanOneYearLapsedSelector)(inactiveMembershipTerm, isAicpaMemberLapsed);
    const hasItemWithThreeMonthRuleProration = (0, exports.hasItemWithThreeMonthRuleProrationSelector)(cartLineItems);
    log.info(`hasItemWithThreeMonthRuleProration - ${hasItemWithThreeMonthRuleProration}`);
    const isLapsedRejoining = isCimaMemberLapsed || isAicpaMemberLapsed || isLapsedCredentialRejoining || isLapsedSectionRejoining;
    log.info(`isLapsedRejoining - ${isLapsedRejoining}`);
    const shouldProrateUserPurchase = (0, firmAdmin_1.areAllTruthy)(useRemoveProration, isLapsedRejoining, !hasItemWithThreeMonthRuleProration, !isAicpaMemberFiveYearsLapsed, !isAicpaMemberMoreThanOneYearLapsed);
    log.info(`shouldProrateUserPurchase - ${shouldProrateUserPurchase}`);
    // for aicpa members, only remove proration when the member is rejoining the same year outside renewal season
    return shouldProrateUserPurchase;
};
exports.isUserQualifiedForRemovingProration = isUserQualifiedForRemovingProration;
const formattedUserProfileData = (userProfile, userOktaData) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    const isActive = (obj) => obj.status === mxp_schemas_1.Salesforce.MembershipStatus.ACTIVE ||
        obj.status === mxp_schemas_1.Salesforce.MembershipStatus.GRACE ||
        obj.status === mxp_schemas_1.Salesforce.MembershipStatus.SUSPENDED;
    const isInactive = (obj) => obj.status === mxp_schemas_1.Salesforce.MembershipStatus.LAPSED ||
        obj.status === mxp_schemas_1.Salesforce.MembershipStatus.RESIGNED ||
        obj.status === mxp_schemas_1.Salesforce.MembershipStatus.TERMINATED;
    const isSuspended = (obj) => obj.status === mxp_schemas_1.Salesforce.MembershipStatus.SUSPENDED;
    return {
        personAccountData: userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount,
        allAddresses: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.allAddresses) || [],
        credentials: ((_a = userProfile === null || userProfile === void 0 ? void 0 : userProfile.credentials) === null || _a === void 0 ? void 0 : _a.filter(isActive)) || [],
        inactiveCredentials: ((_b = userProfile === null || userProfile === void 0 ? void 0 : userProfile.credentials) === null || _b === void 0 ? void 0 : _b.filter(isInactive)) || [],
        suspendedCredentials: ((_c = userProfile === null || userProfile === void 0 ? void 0 : userProfile.credentials) === null || _c === void 0 ? void 0 : _c.filter(isSuspended)) || [],
        sections: ((_d = userProfile === null || userProfile === void 0 ? void 0 : userProfile.sections) === null || _d === void 0 ? void 0 : _d.filter(isActive)) || [],
        inactiveSections: ((_e = userProfile === null || userProfile === void 0 ? void 0 : userProfile.sections) === null || _e === void 0 ? void 0 : _e.filter(isInactive)) || [],
        memberships: ((_f = userProfile === null || userProfile === void 0 ? void 0 : userProfile.memberships) === null || _f === void 0 ? void 0 : _f.filter(isActive)) || [],
        inactiveMemberships: ((_g = userProfile === null || userProfile === void 0 ? void 0 : userProfile.memberships) === null || _g === void 0 ? void 0 : _g.filter(isInactive)) || [],
        customerOrderHistory: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.customerOrderHistory) || [],
        application: userProfile === null || userProfile === void 0 ? void 0 : userProfile.application,
        qualificationData: {
            cpaLicenseData: Object.assign({}, userProfile === null || userProfile === void 0 ? void 0 : userProfile.cpaLicense),
            cpaLicenseListData: {
                cpaLicense: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.cpaLicenses) || [],
            },
        },
        employmentData: {
            employers: (_h = userProfile === null || userProfile === void 0 ? void 0 : userProfile.employers) !== null && _h !== void 0 ? _h : [],
        },
        eventRegistrationData: {
            firstName: (_j = userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount) === null || _j === void 0 ? void 0 : _j.firstName,
            lastName: (_k = userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount) === null || _k === void 0 ? void 0 : _k.lastName,
            emailContactId: (_m = (_l = userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount) === null || _l === void 0 ? void 0 : _l.primaryEmail) === null || _m === void 0 ? void 0 : _m.emailAddress,
        },
        preferences: ((_o = userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount) === null || _o === void 0 ? void 0 : _o.preferences) && JSON.parse(userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount.preferences),
        industryPreferences: ((_p = userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount) === null || _p === void 0 ? void 0 : _p.industryPreferences) && JSON.parse(userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount.industryPreferences),
        trendPreferences: ((_q = userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount) === null || _q === void 0 ? void 0 : _q.trendPreferences) && JSON.parse(userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount.trendPreferences),
        skillPreferences: ((_r = userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount) === null || _r === void 0 ? void 0 : _r.skillPreferences) && JSON.parse(userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount.skillPreferences),
        shortcuts: ((_s = userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount) === null || _s === void 0 ? void 0 : _s.shortcuts) && JSON.parse(userProfile === null || userProfile === void 0 ? void 0 : userProfile.personAccount.shortcuts),
        goldenRecordFetched: true,
        profileFetched: true,
        profileFetchedSuccess: userProfile === null || userProfile === void 0 ? void 0 : userProfile.success,
        hasFirmBillingInvite: userProfile === null || userProfile === void 0 ? void 0 : userProfile.hasFirmBillingInvite,
        quoteStatusAndIsMembershipPaidByFirm: userProfile === null || userProfile === void 0 ? void 0 : userProfile.quoteStatusAndIsMembershipPaidByFirm,
        hasFirmBillingRelation: userProfile === null || userProfile === void 0 ? void 0 : userProfile.hasFirmBillingRelation,
        hasCimaFirmBillingRelation: userProfile === null || userProfile === void 0 ? void 0 : userProfile.hasCimaFirmBillingRelation,
        hasActiveQuoteFromFirm: userProfile === null || userProfile === void 0 ? void 0 : userProfile.hasActiveQuoteFromFirm,
        userUnpaidFirmBillingInvoices: userProfile === null || userProfile === void 0 ? void 0 : userProfile.userUnpaidFirmBillingInvoices,
        exams: userProfile === null || userProfile === void 0 ? void 0 : userProfile.exams,
        tlw: {
            id: (_t = userProfile === null || userProfile === void 0 ? void 0 : userProfile.tlw) === null || _t === void 0 ? void 0 : _t.id,
            isTLW: ((_u = userProfile === null || userProfile === void 0 ? void 0 : userProfile.tlw) === null || _u === void 0 ? void 0 : _u.id) && true,
            tlwReason: (_v = userProfile === null || userProfile === void 0 ? void 0 : userProfile.tlw) === null || _v === void 0 ? void 0 : _v.reason,
            tlwEndDate: (_w = userProfile === null || userProfile === void 0 ? void 0 : userProfile.tlw) === null || _w === void 0 ? void 0 : _w.endDate,
        },
        data: userOktaData,
        userFetched: true,
        loading: false,
        studentProgression: userProfile === null || userProfile === void 0 ? void 0 : userProfile.studentProgression,
        studentExamSectionResults: userProfile === null || userProfile === void 0 ? void 0 : userProfile.studentExamSectionResults,
        zuoraCutOverDate: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.zuoraCutOverDate) || '',
    };
};
exports.formattedUserProfileData = formattedUserProfileData;
const formatProducListData = (productListData) => {
    var _a, _b, _c, _d;
    const memberships = (_a = productListData === null || productListData === void 0 ? void 0 : productListData.lineItems) === null || _a === void 0 ? void 0 : _a.filter((lineItem) => lineItem.productType === mxp_schemas_1.Product.ProductType.MEMBERSHIP);
    const sections = (_b = productListData === null || productListData === void 0 ? void 0 : productListData.lineItems) === null || _b === void 0 ? void 0 : _b.filter((lineItem) => lineItem.productType === mxp_schemas_1.Product.ProductType.SECTION);
    const credentials = (_c = productListData === null || productListData === void 0 ? void 0 : productListData.lineItems) === null || _c === void 0 ? void 0 : _c.filter((lineItem) => lineItem.productType === mxp_schemas_1.Product.ProductType.CREDENTIAL);
    const otherProducts = (_d = productListData === null || productListData === void 0 ? void 0 : productListData.lineItems) === null || _d === void 0 ? void 0 : _d.filter((lineItem) => lineItem.productType !== mxp_schemas_1.Product.ProductType.MEMBERSHIP &&
        lineItem.productType !== mxp_schemas_1.Product.ProductType.SECTION &&
        lineItem.productType !== mxp_schemas_1.Product.ProductType.CREDENTIAL);
    return {
        productsListData: productListData,
        productsListDataFetched: true,
        productListByTypes: {
            memberships,
            sections,
            credentials,
            otherProducts,
        },
    };
};
exports.formatProducListData = formatProducListData;
const isCimaMembershipLapsedSelector = ({ inactiveMembership, isCimaFLPLapsed, isUserMemberLapsed, isUserResigned, }) => {
    return (((inactiveMembership === null || inactiveMembership === void 0 ? void 0 : inactiveMembership.membershipBody) === mxp_schemas_1.MembershipTypes.MembershipBody.CIMA &&
        ((inactiveMembership === null || inactiveMembership === void 0 ? void 0 : inactiveMembership.status) === mxp_schemas_1.Salesforce.MembershipStatus.LAPSED || isUserResigned) &&
        isUserMemberLapsed) ||
        isCimaFLPLapsed);
};
exports.isCimaMembershipLapsedSelector = isCimaMembershipLapsedSelector;
const isAicpaMemberLapsedSelector = (inactiveMembership, isUserMemberLapsed, isUserResigned) => (inactiveMembership === null || inactiveMembership === void 0 ? void 0 : inactiveMembership.membershipBody) === mxp_schemas_1.MembershipTypes.MembershipBody.AICPA &&
    ((inactiveMembership === null || inactiveMembership === void 0 ? void 0 : inactiveMembership.status) === mxp_schemas_1.Salesforce.MembershipStatus.LAPSED || isUserResigned) &&
    isUserMemberLapsed;
exports.isAicpaMemberLapsedSelector = isAicpaMemberLapsedSelector;
const isLapsedCredentialRejoiningSelector = (productListItem, cartLineItems, inactiveCredentials) => {
    var _a;
    let isRejoining = false;
    if ((_a = productListItem === null || productListItem === void 0 ? void 0 : productListItem.credentials) === null || _a === void 0 ? void 0 : _a.length) {
        for (const credential of productListItem === null || productListItem === void 0 ? void 0 : productListItem.credentials) {
            const hasLapsedCredential = inactiveCredentials === null || inactiveCredentials === void 0 ? void 0 : inactiveCredentials.some((inactiveCredential) => { var _a; return (inactiveCredential === null || inactiveCredential === void 0 ? void 0 : inactiveCredential.sku) === ((_a = credential === null || credential === void 0 ? void 0 : credential.variant) === null || _a === void 0 ? void 0 : _a.sku); });
            isRejoining = cartLineItems === null || cartLineItems === void 0 ? void 0 : cartLineItems.some((cartLineItem) => hasLapsedCredential && (cartLineItem === null || cartLineItem === void 0 ? void 0 : cartLineItem.productSlug) === (credential === null || credential === void 0 ? void 0 : credential.productSlug));
            if (isRejoining)
                break;
        }
    }
    return isRejoining;
};
exports.isLapsedCredentialRejoiningSelector = isLapsedCredentialRejoiningSelector;
const isLapsedSectionRejoiningSelector = (inactiveSections, lineItems) => {
    let isRejoining = false;
    for (const section of inactiveSections) {
        isRejoining = lineItems === null || lineItems === void 0 ? void 0 : lineItems.some((lineItem) => { var _a; return ((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant) === null || _a === void 0 ? void 0 : _a.sku) === (section === null || section === void 0 ? void 0 : section.sku); });
        if (isRejoining)
            break;
    }
    return isRejoining;
};
exports.isLapsedSectionRejoiningSelector = isLapsedSectionRejoiningSelector;
const isAicpaMemberMoreThanOneYearLapsedSelector = (inactiveMembershipTerm, isUserAicpaMemberLapsed) => (0, firmAdmin_1.areAllTruthy)(isUserAicpaMemberLapsed, (0, moment_timezone_1.default)().diff(inactiveMembershipTerm === null || inactiveMembershipTerm === void 0 ? void 0 : inactiveMembershipTerm.expiryDate, 'year') >= 1);
exports.isAicpaMemberMoreThanOneYearLapsedSelector = isAicpaMemberMoreThanOneYearLapsedSelector;
const hasItemWithThreeMonthRuleProrationSelector = (cartLineItems) => {
    return cartLineItems === null || cartLineItems === void 0 ? void 0 : cartLineItems.some(lineItem => {
        var _a, _b, _c, _d, _e, _f, _g;
        const startMonth = (_c = (_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.membershipMonthStart) === null || _c === void 0 ? void 0 : _c.label;
        const endMonth = (_f = (_e = (_d = lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant) === null || _d === void 0 ? void 0 : _d.attributes) === null || _e === void 0 ? void 0 : _e.membershipMonthEnd) === null || _f === void 0 ? void 0 : _f.label;
        if (startMonth && endMonth) {
            return ((_g = (0, index_1.calculateProration)(startMonth, endMonth)) === null || _g === void 0 ? void 0 : _g.monthsProrated) > 12;
        }
        return false;
    });
};
exports.hasItemWithThreeMonthRuleProrationSelector = hasItemWithThreeMonthRuleProrationSelector;
const isAicpaMemberFiveYearsLapsedSelector = (inactiveMembershipTerm, isUserAicpaMemberLapsed) => (0, firmAdmin_1.areAllTruthy)(isUserAicpaMemberLapsed, (0, moment_timezone_1.default)().diff(inactiveMembershipTerm === null || inactiveMembershipTerm === void 0 ? void 0 : inactiveMembershipTerm.expiryDate, 'year') >= 5);
exports.isAicpaMemberFiveYearsLapsedSelector = isAicpaMemberFiveYearsLapsedSelector;
const isCimaFLPLapsedSelector = ({ inactiveMembership, learningPathway, isUserResigned, isUserMemberLapsed, }) => {
    return (learningPathway === mxp_schemas_1.MembershipTypes.Pathway.FLP &&
        ((inactiveMembership === null || inactiveMembership === void 0 ? void 0 : inactiveMembership.status) === mxp_schemas_1.Salesforce.MembershipStatus.LAPSED || isUserResigned) &&
        isUserMemberLapsed);
};
exports.isCimaFLPLapsedSelector = isCimaFLPLapsedSelector;
const learningPathwaySelector = (personAccountData) => {
    return personAccountData === null || personAccountData === void 0 ? void 0 : personAccountData.learningPathway;
};
exports.learningPathwaySelector = learningPathwaySelector;
const isUserMemberLapsedSelector = (userData) => {
    return [
        mxp_schemas_1.MembershipTypes.MembershipState.LAPSED,
        mxp_schemas_1.MembershipTypes.MembershipState.RESIGNED,
        mxp_schemas_1.MembershipTypes.MembershipState.TERMINATED,
    ].includes(userData.memberStatus ||
        userData.memberType);
};
exports.isUserMemberLapsedSelector = isUserMemberLapsedSelector;
const isUserResignedSelector = (userData, inactiveMembership) => {
    return (userData.memberStatus === mxp_schemas_1.MembershipTypes.MembershipState.RESIGNED ||
        (inactiveMembership === null || inactiveMembership === void 0 ? void 0 : inactiveMembership.status) === mxp_schemas_1.Salesforce.MembershipStatus.RESIGNED ||
        userData.memberStatus === mxp_schemas_1.MembershipTypes.MembershipState.TERMINATED);
};
exports.isUserResignedSelector = isUserResignedSelector;
const inactiveMembershipTermSelector = (inactiveMemberships) => { var _a, _b, _c; return ((_a = ((inactiveMemberships === null || inactiveMemberships === void 0 ? void 0 : inactiveMemberships[0]) || {})) === null || _a === void 0 ? void 0 : _a.membershipTerm) || ((_c = (_b = ((inactiveMemberships === null || inactiveMemberships === void 0 ? void 0 : inactiveMemberships[0]) || {})) === null || _b === void 0 ? void 0 : _b.inactiveTerms) === null || _c === void 0 ? void 0 : _c[0]); };
exports.inactiveMembershipTermSelector = inactiveMembershipTermSelector;
//# sourceMappingURL=index.js.map